import { render, staticRenderFns } from "./QuanLyTaiChinh.vue?vue&type=template&id=bc201118"
import script from "./QuanLyTaiChinh.vue?vue&type=script&lang=js"
export * from "./QuanLyTaiChinh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports